import React, { useEffect, useState } from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import AdminDashboard from './AdminDashboard';
import { API_BASE_URL } from '../../config';

const getAdminHeaders = () => {
  const adminToken = localStorage.getItem('adminToken');
  const authToken = localStorage.getItem('authToken');
  const token = adminToken || authToken;
  return token ? { Authorization: `Bearer ${token}` } : {};
};

export default function AdminProtected() {
  const [status, setStatus] = useState('checking'); // 'checking' | 'ok' | 'no'

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const API = API_BASE_URL;
        // Check admin-specific endpoint so admin_token scoped to /auth/admin
        // is used for admin verification instead of interfering with normal
        // user sessions.
        const res = await fetch(`${API}/auth/admin/me`, { credentials: 'include', headers: getAdminHeaders() });
        if (!mounted) return;
        if (res.ok) {
          const j = await res.json().catch(() => null);
          if (j && j.isAdmin) setStatus('ok'); else setStatus('no');
        } else {
          setStatus('no');
        }
      } catch (e) {
        setStatus('no');
      }
    })();
    return () => { mounted = false; };
  }, []);

  if (status === 'checking') return <div className="p-8">Yükleniyor...</div>;
  if (status === 'no') return <Navigate to="/admin/login" replace />;
  // When authenticated, render nested admin routes via Outlet.
  // Keep AdminDashboard as the index route in App.js children.
  return <Outlet />;
}
